import React, { useState } from "react";
import { Button, Header, Form, Icon, Segment } from "semantic-ui-react";

export default function Abandon(props) {
  const [note, setNote] = useState("");

  return (
    <Segment padded textAlign="center">
      <Icon size="massive" name="exclamation circle" color="yellow" />
      <Header
        content="Are you sure?"
        subheader="You are about to abandon this contract. This contract will no longer be available to view, edit, or execute."
        size="huge"
        style={{
          margin: "12px 0 40px 0",
        }}
      />
      <Form size="large" style={{ width: "450px", margin: "0 auto 2em auto" }}>
        <Form.TextArea
          label="Please tell us why you are abandoning this contract"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </Form>
      <Button content="Cancel" onClick={props.onClose} basic />
      <Button
        content="Yes, I'm sure. Abandon this contract."
        onClick={() => props.onConfirm(note)}
        disabled={!note}
        basic
      />
    </Segment>
  );
}
